/* eslint-disable no-unused-vars, max-len */
const { feWp } = window;
const { addAction } = feWp.hooks;

const configureSwiper = ( settings, swiper ) => {
  Object.assign( swiper.params, {
    threshold: 2,
    preventClicks: false,
    preventClicksPropagation: false
  } );
  if ( settings.loop ) {
    Object.assign( swiper.params, {
      supports4k: true,
      longSwipesRatio: 0,
      threshold: 0,
      touchRatio: 0.1
    } );
    swiper.update();
  }
};

const stopAutoPlay = ( sliderObj ) => sliderObj.autoplay.stop();
const startAutoPlay = ( sliderObj ) => sliderObj.autoplay.start();

const setAnimationDuration = ( sliderObj, duration ) => {
  sliderObj.el.querySelectorAll( '.line-animator' )?.forEach( line => {
    line.style.animationDuration = `${duration}ms`;
  } );
};

const handleInteraction = ( swiper, navSwiper, el ) => {
  setAnimationDuration( navSwiper, 0 );
  stopAutoPlay( swiper );
  el.parentNode.classList.add( 'autoplay-stop' );
};

const changeToFirstSlide = ( sliderObj, settings ) => {
  if( settings.loop ) {
    sliderObj.slideToLoop( 0 );
  } else {
    sliderObj.slideTo( 0 );
  }
};
const setupIntersectionObserver = ( el, swiper, navSwiper, settings ) => {
  const observer = new IntersectionObserver( ( entries ) => {
    entries.forEach( entry => {
      if ( entry.isIntersecting ) {
        el.parentNode.classList.add( 'tab-slider-in-view' );
        if ( settings.autoplay && !el.parentNode.classList.contains( 'autoplay-stop' ) ) {
          changeToFirstSlide( swiper, settings );
          startAutoPlay( swiper );
        }
        observer.unobserve( entry.target );
      } else {
        el.parentNode.classList.remove( 'tab-slider-in-view' );
        if ( settings.autoplay && !el.parentNode.classList.contains( 'autoplay-stop' ) ) {
          changeToFirstSlide( swiper, settings );
          stopAutoPlay( swiper );
        }
      }
    } );
  } );
  observer.observe( el );
};

const initSliderContent = ( settings, el, swiper ) => {
  configureSwiper( settings, swiper );

  const navSwiper = swiper.thumbs.swiper;
  if ( swiper.el.closest( '.e-tbs .e-tbs__content' ) ) {
    const animateDuration = settings.autoplay ? settings.autoplay.delay: 0;
    setAnimationDuration( navSwiper, animateDuration );

    stopAutoPlay( swiper );
    swiper.slideTo( 0 );

    navSwiper.on( 'click', () => handleInteraction( swiper, navSwiper, el ) );
    swiper.on( 'touchEnd', () => handleInteraction( swiper, navSwiper, el ) );

    setupIntersectionObserver( el, swiper, navSwiper, settings );
  }
};

addAction( 'b3rg_tab_slider_content_init', 'b3rg/tab-slider', initSliderContent );

addAction( 'b3rg_tab_slider_nav_init', 'b3rg/tab-slider', ( settings, el, swiper ) => {
  configureSwiper( settings, swiper );
} );
